import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { CUISINE_TYPE_QUERY } from '../graphql/queries'
import { FETCH_CUISINE_TYPE } from '../redux/action-types'
import { cleanupFetchCuisineType } from '../redux/actions'

const useCuisineTypeQuery = id => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchCuisineType)

  const { isLoading, error, data } = useSelector(
    store => store.cuisineTypes.cuisineType,
  )

  const refetch = useCallback(
    id =>
      apolloService.query(
        CUISINE_TYPE_QUERY,
        { id },
        dispatch,
        FETCH_CUISINE_TYPE,
      ),

    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [id, refetch])

  return { isLoading, error, data }
}

export default useCuisineTypeQuery
